import subtractDays from 'date-fns/sub_days';
import subtractMonths from 'date-fns/sub_months';

export const EXPENSE_PAGE = {
  data: {
    title: 'Потребление услуг',
    text: 'Интернет за',
    date: '3 ноября',
  },
  call: {
    title: 'Потребление услуг',
    text: 'Звонки за',
    date: '3 ноября',
  },
  sms: {
    title: 'Потребление услуг',
    text: 'Сообщения за',
    date: '3 ноября',
  },
  dataRoaming: {
    title: 'Потребление услуг',
    text: 'Интернет в роуминге за',
    date: '3 ноября',
  },
  callRoaming: {
    title: 'Потребление услуг',
    text: 'Звонки в роуминге за ',
    date: '3 ноября',
  },
  smsRoaming: {
    title: 'Потребление услуг',
    text: 'Сообщения в роуминге за ',
    date: '3 ноября',
  },
};

export const DROPDOWN_LIST = [
  {
    label: 'Сутки',
    slug: 'day',
  },
  {
    label: 'Неделю',
    slug: 'week',
  },
  {
    label: 'Две недели',
    slug: 'two-weeks',
  },
  {
    label: 'Месяц',
    slug: 'month',
  },
];

export const DATE_DROPDOWN = [
  ...DROPDOWN_LIST,
  {
    label: 'Выбрать период',
    slug: 'choose-period',
  },
];

export const DROPDOWN_BALANCE = [
  {
    label: 'Все балансы',
    slug: 1,
    filterId: 'categoryName',
  },
  {
    label: 'Основной баланс',
    slug: 2,
    filterId: 'categoryName',
  },
  {
    label: 'Бонусный баланс',
    slug: 3,
    filterId: 'categoryName',
  },
  {
    label: 'Корпоративный баланс',
    slug: 4,
    filterId: 'categoryName',
  },
];

export const DROPDOWN_ROAMING_CALL = [
  {
    label: 'Все звонки',
    slug: 1,
  },
  {
    label: 'Входящие',
    slug: 2,
    filterId: 'INTERNATIONAL_ROAMING_INCOMING_CALLS',
  },
  {
    label: 'Исходящие',
    slug: 3,
    filterId: 'INTERNATIONAL_ROAMING_OUTCOMING_CALLS',
  },
  {
    label: 'Международные',
    slug: 3,
    filterId: 'INTERNATIONAL_CALLS_ND',
  },
];

export const DROPDOWN_LOCAL_CALL = [
  {
    label: 'Все звонки',
    slug: 1,
  },
  {
    label: 'Входящие',
    slug: 2,
    filterId: 'LOCAL_INCOMING_CALLS',
  },
  {
    label: 'Исходящие',
    slug: 3,
    filterId: 'LOCAL_OUTCOMING_CALLS_RUSSIA',
  },
  {
    label: 'Международные',
    slug: 3,
    filterId: 'INTERNATIONAL_CALLS_ND',
  },
];

export const DATE_PERIOD = {
  day: new Date(),
  week: subtractDays(new Date(), 6),
  'two-weeks': subtractDays(new Date(), 13),
  month: subtractMonths(new Date(), 1),
  'choose-period': new Date(),
};
